import axios from 'axios';
import previewReviewAskConfig from '@/views/response/preview_review_ask_config.json';
import createRandomId from '@/lib/createRandomId';

export const reviewAskOrigin = (cremaDomainPrefix = '') =>
  `https://${cremaDomainPrefix}review-ask.cre.ma`;

export const reviewAskApiOrigin = (cremaDomainPrefix = '') =>
  `https://${cremaDomainPrefix}review-ask-api.cre.ma`;

export const CONFIG_TIMEOUT_MS = 1500;

const EVENTS_RETRY_LIMIT = 2;

// fetch + keepalive로 보낸다. sendBeacon은 application/json을 교차 출처로 보낼 수 없다.
// 400·403·413은 재시도해도 같은 결과라 버리고, 5xx·네트워크 오류만 제한 횟수만큼 재시도한다.
const postEvents = async (url, events, attempt = 0) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ events }),
      keepalive: true,
      credentials: 'omit'
    });
    if (response.status < 500) return;
  } catch (e) {
    // 네트워크 오류는 아래에서 재시도한다.
  }
  if (attempt >= EVENTS_RETRY_LIMIT) return;
  await new Promise(resolve => setTimeout(resolve, 500 * 2 ** attempt));
  return postEvents(url, events, attempt + 1);
};

class ReviewAskApi {
  constructor(brandCode, cremaDomainPrefix = '', dummy = false) {
    this.brandCode = brandCode;
    this.dummy = dummy;
    this.api = axios.create({
      baseURL: reviewAskApiOrigin(cremaDomainPrefix),
      timeout: CONFIG_TIMEOUT_MS
    });
  }

  fetchConfig({ productId, pageViewId, secureDeviceToken }) {
    if (!this.dummy)
      return this.api.get('/entry', {
        params: {
          brand_code: this.brandCode,
          product_id: productId,
          page_view_id: pageViewId,
          secure_device_token: secureDeviceToken
        }
      });
    return Promise.resolve({ data: previewReviewAskConfig });
  }

  sendEntryImpression({ productId, pageViewId, secureDeviceToken }) {
    if (this.dummy) return;

    const event = {
      event_id: createRandomId(),
      event_type: 'entry_impression',
      brand_code: this.brandCode,
      product_id: Number(productId),
      occurred_at: new Date().toISOString(),
      page_view_id: pageViewId,
      secure_device_token: secureDeviceToken
    };
    postEvents(`${this.api.defaults.baseURL}/events`, [event]).catch(() => {});
  }
}

export default ReviewAskApi;
